import { render, staticRenderFns } from "./ExamStudentWriting.vue?vue&type=template&id=6970dfb5"
import script from "./ExamStudentWriting.vue?vue&type=script&lang=js"
export * from "./ExamStudentWriting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports